import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface DetailAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.quotations.decline
function* declineQuotationsSaga({ payload }) {
    try {
        const response = yield axios.get(`/companies/quotations/decline/${payload.id}`)
        if (response.success) {
            yield put(onSuccess({ data: response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* declineQuotations(): any {
    yield takeLatest<DetailAction>(onRequest, declineQuotationsSaga)
}

export default declineQuotations
